import { render, staticRenderFns } from "./qa.vue?vue&type=template&id=4f363db8&scoped=true"
import script from "./qa.vue?vue&type=script&lang=js"
export * from "./qa.vue?vue&type=script&lang=js"
import style0 from "./qa.vue?vue&type=style&index=0&id=4f363db8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f363db8",
  null
  
)

export default component.exports